/** ISO 3166-2 subdivision codes for German Bundesländer (Nager.Date / Feiertags-API). */
export const GERMAN_STATE_CODES = [
  'DE-BW',
  'DE-BY',
  'DE-BE',
  'DE-BB',
  'DE-HB',
  'DE-HH',
  'DE-HE',
  'DE-MV',
  'DE-NI',
  'DE-NW',
  'DE-RP',
  'DE-SL',
  'DE-SN',
  'DE-ST',
  'DE-SH',
  'DE-TH',
] as const;

export type GermanStateCode = (typeof GERMAN_STATE_CODES)[number];

const GERMAN_STATE_CODE_SET = new Set<string>(GERMAN_STATE_CODES);

export const GERMAN_STATES: ReadonlyArray<{ value: GermanStateCode; label: string }> = [
  { value: 'DE-BW', label: 'Baden-Württemberg' },
  { value: 'DE-BY', label: 'Bayern' },
  { value: 'DE-BE', label: 'Berlin' },
  { value: 'DE-BB', label: 'Brandenburg' },
  { value: 'DE-HB', label: 'Bremen' },
  { value: 'DE-HH', label: 'Hamburg' },
  { value: 'DE-HE', label: 'Hessen' },
  { value: 'DE-MV', label: 'Mecklenburg-Vorpommern' },
  { value: 'DE-NI', label: 'Niedersachsen' },
  { value: 'DE-NW', label: 'Nordrhein-Westfalen' },
  { value: 'DE-RP', label: 'Rheinland-Pfalz' },
  { value: 'DE-SL', label: 'Saarland' },
  { value: 'DE-SN', label: 'Sachsen' },
  { value: 'DE-ST', label: 'Sachsen-Anhalt' },
  { value: 'DE-SH', label: 'Schleswig-Holstein' },
  { value: 'DE-TH', label: 'Thüringen' },
];

/** Returns a valid Bundesland code or `null` when empty / unknown. */
export function normalizeGermanStateCode(raw: unknown): string | null {
  const code = String(raw ?? '').trim().toUpperCase();
  if (!code) return null;
  return GERMAN_STATE_CODE_SET.has(code) ? code : null;
}
